module.exports = __webpack_public_path__ + "static/media/TopUp.989c5108.svg";